import { useEffect, useState } from 'react';
import { useMatch } from 'react-router-dom';
import { BaseTransaction, useGetList, useQueryState } from '@ui/src';
import { overviewAccountsSchema } from '../variables/statements-accounts';
import { overviewCardsSchema } from '../variables/statements-cards';
import { amlAccountsSchema } from '../variables/statements-aml';
import { useLazyGetCustomerTransactionsWithWarningsQuery } from '../../../customers/store/services/customers';
import { OrganizationType } from '../../types';

const useAmlStatements = ({
  matchPath,
  customerType,
  customerId,
}: {
  matchPath: string;
  customerType: OrganizationType;
  customerId?: string;
}) => {
  const [dates, setDates] = useState<string[]>([]);

  const match = useMatch(matchPath);

  let schema: any = overviewAccountsSchema;

  if (match) {
    schema = overviewCardsSchema;
  }

  const { filters, onFilterChange } = useQueryState(schema);

  const [
    getCustomerTransactionsWithWarningsQuery,
    {
      isLoading: customerTransactionsIsLoading,
      isFetching: customerTransactionsIsFetching,
    },
  ] = useLazyGetCustomerTransactionsWithWarningsQuery();

  const { getListAction, setPage, onFilter, errorList } =
    useGetList<BaseTransaction>({
      getList: getCustomerTransactionsWithWarningsQuery,
      onFilterChange,
      onSortChange: () => {},
      itemId: customerId,
      schema: amlAccountsSchema,
    });

  useEffect(() => {
    if (customerType && customerId) {
      getListAction({ ...filters });
    }
  }, [customerType, customerId]);

  return {
    dates,
    setDates,
    filters,
    onFilter,
    customerTransactionsIsLoading,
    customerTransactionsIsFetching,
    errorList,
    setPage,
  };
};

export default useAmlStatements;
